import { jsPDF } from "jspdf";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc =
    `${window.location.origin}/pdf.worker.min.js`;

const formatMonthYear = (dateString) => {
    if (!dateString) return "";
    const [year, month] = dateString.split("-");
    return new Intl.DateTimeFormat("en-US", { year: "numeric", month: "long" }).format(new Date(year, month - 1));
};

const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", hour12: true
    }).format(new Date(dateString));
};

export async function batchReport(batch, skuImage, snappedPdfImage, sku) {
    const doc = new jsPDF();
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 210, 35, 'F');
    try {
        doc.addImage("logo.png", 'PNG', 10, 5, 30, 25);
        doc.addImage("QRmor.jpeg", "PNG", 175, 5, 30, 25);
    }
    catch { }
    doc.setTextColor(0);
    doc.setFontSize(24);
    doc.text('BATCH INFORMATION REPORT', 108, 15, { align: 'center' });
    doc.setFontSize(10);
    doc.text(`Generated: ${new Date().toLocaleString()} | ${sessionStorage.getItem('name')}`, 105, 25, { align: 'center' });
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text('Product Details', 20, 50);

    const getBase64FromUrl = async (url) => {
        const res = await fetch(url);
        const blob = await res.blob();
        return new Promise((resolve) => {
            const r = new FileReader();
            r.onloadend = () => resolve(r.result);
            r.readAsDataURL(blob);
        });
    };

    try {
        const img = await getBase64FromUrl(skuImage);
        doc.addImage(img, 'JPEG', 145, 55, 50, 50);
        if (snappedPdfImage) {
            doc.setDrawColor(180);
            doc.rect(164, 110, 30, 30);
            doc.addImage(snappedPdfImage, "PNG", 165, 111, 28, 28);
            doc.setFontSize(9);
            doc.setTextColor(100);
            doc.text("Sample QRmor Code Snapshot *", 158, 144);
            doc.text("*For representation purposes only. Not a functional QRmor code.", 10, 295);
            doc.setTextColor(0);
        }
    } catch { }

    doc.setFontSize(11);
    doc.setFont(undefined, 'normal');
    const details = [
        { label: 'QR UID:', value: sessionStorage.getItem('qrUid') },
        //   { label: 'QR Generated at:', value: formatDate(sessionStorage.getItem('qrCreatedAt')) },
        { label: 'Product Name:', value: sku.brand_name },
        { label: 'Unique Product Identification Code:', value: sku.gtin },
        { label: 'Generic Name:', value: sku.generic_name },
        { label: 'Manufacturing Lic. No.:', value: sku.manufacturing_license },
        { label: 'Batch No.:', value: batch.batch_no },
        { label: 'Date of Manufacturing:', value: formatMonthYear(batch.dom) },
        { label: 'Date of Expiry:', value: formatMonthYear(batch.doe) },
        { label: 'Manufacturer Name & Address:', value: sku.prod_unit + "\n" + sku.address },
        { label: 'List of Excipients:', value: sku.excipients }
    ];
    let yPos = 60;
    let wrapped;
    details.forEach(d => {
        doc.setFont(undefined, "bold");
        doc.text(d.label, 20, yPos);
        doc.setFont(undefined, "normal");
        if (d.label === "Generic Name")
            wrapped = doc.splitTextToSize(String(d.value || "-"), 45);
        else
            wrapped = doc.splitTextToSize(String(d.value || "-"), 68);
        wrapped.forEach((line, i) => doc.text(line, 92, yPos + i * 7));
        yPos += wrapped.length * 6 + 2;
    });
    if (yPos < 110) yPos = 110;
    yPos += 10;
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text('Remarks', 20, yPos);
    yPos += 10;
    doc.setFontSize(10);
    doc.setFillColor(0, 48, 135);
    doc.rect(10, yPos - 7, 190, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont(undefined, 'bold');
    doc.text('No.', 15, yPos);
    doc.text('Remarks.', 30, yPos);
    doc.text('Timestamp', 150, yPos);
    doc.setTextColor(0, 0, 0);
    doc.setFont(undefined, 'normal');
    yPos += 10;

    batch.remarks.forEach((row, index) => {
        const lines = doc.splitTextToSize(row.message, 110);
        const rowHeight = Math.max(10, lines.length * 7);
        if (yPos + rowHeight > 270) {
            doc.addPage();
            yPos = 20;
        }
        if (index % 2 === 0) {
            doc.setFillColor(245, 245, 245);
            doc.rect(10, yPos - 7, 190, rowHeight + 2, 'F');
        }
        doc.text((index + 1).toString(), 15, yPos);
        doc.text(lines, 30, yPos);
        doc.text(formatDate(row.timestamp), 150, yPos);
        yPos += rowHeight;
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(128, 128, 128);
        doc.text(`Page ${i} of ${pageCount}`, 105, 290, { align: 'center' });
        doc.text('Confidential — For Internal Use Only', 105, 285, { align: 'center' });
        doc.setFontSize(9);
        doc.setTextColor(100);
        doc.text("QRmor Asset Security Analytics Report", 140, 280);
        doc.text('© 2026 Scinova Scientifics', 150, 285);
        doc.text('Powered by CIIRC®', 155, 290);
    }
    doc.setTextColor(0, 0, 0);
    doc.text('End of Report', 105, yPos + 10, { align: 'center' });
    doc.text('__________________________', 150, yPos + 20);
    doc.text('Batch Verifier Personnel Signature', 149, yPos + 25);
    doc.text('__________________________', 20, yPos + 20);
    doc.text('Batch Entry Personnel Signature', 19, yPos + 25);
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(new File([pdfBlob], `Batch_${batch.batch_no}_Report.pdf`, { type: "application/pdf" }));
    window.open(pdfUrl, "_blank");
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 15000);
};